import page from './page'

function index() {
  page()
}

export default index
